import { AchEnrollment } from '@src/app/features/ach-enrollment/models/ach-enrollment.model';

export interface AchEnrollmentState {
    achEnrollment: AchEnrollment | null;
}

export const initialState: AchEnrollmentState = {
    achEnrollment: null,
};
